import React, { useEffect } from "react";
import "./DashBoard.css";

import { useState } from "react";
import { useRef } from "react";
import user_logo from "../../../assets/svg/user-logo.svg";
import van_logo from "../../../assets/svg/van-logo.svg";
import couriers_logo from "../../../assets/svg/couries-logo.svg";
import up_arrow from "../../../assets/svg/up-arrow.svg";
import down_arrow_red from "../../../assets/svg/down_arrow_red.svg";
import meeting_icon from "../../../assets/svg/meeting_icon.svg";
import business_icon from "../../../assets/svg/business_icon.svg";
import cleaning_icon from "../../../assets/svg/cleaning_icon.svg";
import internship_icon from "../../../assets/svg/internship_icon.svg";
import worker_icon from "../../../assets/svg/worker_icon.svg";
import manual_entr_ic from "../../../assets/svg/manual_entr_ics.svg";
import qr_icon from "../../../assets/svg/qr_icon.svg";
import average_gate from "../../../assets/svg/average_gate_icon.svg";
import scheduled_icon from "../../../assets/svg/scheduled_icon.svg";
import vehicles_icon from "../../../assets/svg/vehicles_icon.svg";
import overstayed_icon from "../../../assets/svg/visitors_icon.svg";
import union_icon from "../../../assets/svg/Union_icon.svg";
import line_border from "../../../assets/svg/line-border.svg";
import total_attendance_user from "../../../assets/svg/total-attendance-user.svg";
import total_attendance_vehicle from "../../../assets/svg/total-attendance-vehicle.svg";
import total_attendance_courier from "../../../assets/svg/total-attendance-courier.svg";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import {
  getAverageApi,
  getCount,
  getCourierCountApi,
  getEntryBasedApi,
  getMonthlyCountApi,
  getOverstayCountApi,
  getPurposeApi,
  getRegisterCountApi,
  getTodayCountApi,
} from "./dashboard-api";
import { Container, Row, Col } from "react-bootstrap";
import BarChart from "../../common/barchart";
import { useGlobal } from "../../../GlobalContext";

const GateNewDashboard = ({
  interval = 10,
  widgets = [
    // {
    //   id: 1,
    //   name: "Count details",
    //   seq_no: 1,
    //   status: true,
    // },
    // {
    //   id: 2,
    //   name: "Average Gate in Activities",
    //   seq_no: 2,
    //   status: true,
    // },
    // {
    //   id: 3,
    //   name: "Purpose based visitor",
    //   seq_no: 3,
    //   status: true,
    // },
    // {
    //   id: 4,
    //   name: "Entry based",
    //   seq_no: 4,
    //   status: true,
    // },
    // {
    //   id: 5,
    //   name: "Upcoming and Overstayed visitors",
    //   seq_no: 5,
    //   status: true,
    // },
    // {
    //   id: 6,
    //   name: "Courier status",
    //   seq_no: 6,
    //   status: true,
    // },
    // {
    //   id: 7,
    //   name: "Total registrations",
    //   seq_no: 7,
    //   status: true,
    // },
    // {
    //   id: 8,
    //   name: "Monthly bookings",
    //   seq_no: 8,
    //   status: true,
    // },
    // {
    //   id: 9,
    //   name: "Today attendance",
    //   seq_no: 9,
    //   status: true,
    // },
  ],
}) => {
  let { dashboardToken } = useGlobal();
  if (process.env.REACT_APP_ENVIRONMENT === "development") {
    dashboardToken =
      "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS11YXQubWF3YWxvZy5jb20vc2lnbmFnZS92MS9hcGkvZGV2aWNlLzY3IiwiaWF0IjoxNzY3MTM5MTk5LCJleHAiOjE3OTg2NzUxOTksIm5iZiI6MTc2NzEzOTE5OSwianRpIjoiTGtBTU5qdHhCanFxNFBhRSIsInN1YiI6IjY3IiwicHJ2IjoiYjkwZjcxZjJiMDQ2ZjM1NDJhMDI3ODEwODllYTc1NjY4ZmUzYWU2MyIsImF1dGhpZCI6MTIzMiwib3JnaWQiOjEwNSwidXNlcmlkIjoxMjMyLCJkYXRhYmFzZW5hbWUiOiJyYWd1cnIiLCJvcmdfY29kZSI6InJhZ3VyciIsInRpbWV6b25lIjoiIiwicm9sZWlkIjo0OTcsInBheW1lbnRfc3RhdHVzIjp0cnVlLCJhdXRob3JpdGllcyI6WyJST0xFX1VTRVIiXSwiZGV2aWNlSWQiOjY3LCJncm91cElkIjo1Miwic2lnbmFnZV9jb2RlIjoiIn0.VpzQxFgAA2lqyRoIrKp9kkOiAg6j1-k7sfYQj9VO-4A";
  }

  const intervalRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const progressRef = useRef(null);
  const currentMonth = new Date().toLocaleString("default", { month: "short" });

  const purposes = [
    { name: "Meeting", icon: meeting_icon, count: 665, percentage: 75 },
    { name: "Business", icon: business_icon, count: 443, percentage: 55 },
    { name: "Internship", icon: internship_icon, count: 542, percentage: 80 },
    { name: "Cleaning", icon: cleaning_icon, count: 197, percentage: 65 },
    { name: "Worker", icon: worker_icon, count: 1585, percentage: 85 },
  ];

  const [preRegisterWidth, setPreRegisterWidth] = useState(50);
  const myRef = useRef(null);
  const [directRegisterWidth, setDirectRegisterWidth] = useState(85);
  const [hoveredBar, setHoveredBar] = useState(null);

  const [activeService, setActiveService] = useState("visitor");
  const [isOpen, setIsOpen] = useState(false);
  const [gateDetials, setIsGateDetials] = useState({});
  const [orgCreateDate, setOrgCreateDate] = useState("");
  const [averageDetails, setAverageDetails] = useState({});
  const [visitorDetails, setvisitorDetails] = useState({});
  const [vehicleDetails, setvehicleDetails] = useState({});
  const [courierDetails, setcourierDetails] = useState({});
  const [purposeslist, setpurposeslist] = useState([]);
  const [totalpercentPurpose, settotalpercentPurpose] = useState(0);
  const [purposesTotal, setpurposesTotal] = useState(0);
  const [qrPerct, setqrPerct] = useState(0);
  const [manualPerct, setmanualPerct] = useState(0);
  const [entryCounts, setEntryCounts] = useState({});
  const [overCount, setOverCount] = useState({});
  const [courierCount, setcourierCount] = useState({});
  const [registCount, setregistCount] = useState({});
  const [todayAttCount, settodayAttCount] = useState({});
  const [todayAttVistCount, settodayAttVistCount] = useState({});
  const [todayAttVehCount, settodayAttVehCount] = useState({});
  const [todayAttCourCount, settodayAttCourCount] = useState({});
  const [todayAttvalueCount, settodayAttvalueCount] = useState(0);
  const [toAttVisitPercent, settoAttVisitPercent] = useState(0);
  const [toAttVehPercent, settoAttVehPercent] = useState(0);
  const [toAttCourPercent, settoAttCourPercent] = useState(0);
  const [monthlyDiff, setmonthlyDiff] = useState(0);
  const [monthlyPercent, setmonthlyPercent] = useState(0);
  const [monthlyIsLow, setmonthlyIsLow] = useState(false);
  const [monthlyList, setMonthlyList] = useState([]);
  const [visitormonthlyList, setvisitorMonthlyList] = useState([]);
  const [vehiclemonthlyList, setvehicleMonthlyList] = useState([]);
  const [couriermonthlyList, setvcourierMonthlyList] = useState([]);
  const [isAttendanceOpen, setIsAttendanceOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("Feb");
  const [selectedYear, setSelectedYear] = useState("2024");
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [selectedDay, setSelectedDay] = useState(23);
  const [selectedAttendanceMonth, setSelectedAttendanceMonth] = useState("Feb");
  const [selectedAttendanceYear, setSelectedAttendanceYear] = useState("2024");
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const years = Array.from({ length: 20 }, (_, i) => 2030 - i);
  const days = Array.from({ length: 31 }, (_, i) => i + 1);

  const [sortedWidgetList, setSortedWidgetList] = useState([]);
  useEffect(() => {
    setSortedWidgetList([...widgets].sort((a, b) => a.seq_no - b.seq_no));
  }, []);

  const callAllAPIs = () => {
    const apiMap = {
      "Count details": getCounts,
      "Average Gate in Activities": getAverageDetails,
      "Purpose based visitor": getpurposes,
      "Entry based": getEntries,
      "Upcoming and Overstayed visitors": getOverStayCount,
      "Courier status": getCourierCounts,
      "Total registrations": getregisCounts,
      "Monthly bookings": () => getmonthlycounts(activeService),
      "Today attendance": gettodayCounts,
    };

    widgets.forEach((widget) => {
      if (widget.status && apiMap[widget.name]) {
        apiMap[widget.name]();
      }
    });
  };

  useEffect(() => {
    // Initial API call
    callAllAPIs();

    // Setup interval
    intervalRef.current = setInterval(() => {
      callAllAPIs();
    }, interval * 1000); // convert seconds to ms

    // Cleanup on unmount
    return () => clearInterval(intervalRef.current);
  }, [interval]);
  useEffect(() => {}, []);
  const handleSelect = (month, year) => {
    setSelectedMonth(month);
    setSelectedYear(year);
    setIsOpen(false);
  };
  const handleAttendanceSelect = (day, month, year) => {
    setSelectedDay(day);
    setSelectedAttendanceMonth(month);
    setSelectedAttendanceYear(year);
    setIsAttendanceOpen(false);
  };

  const getAverageDetails = async () => {
    try {
      const response = await getAverageApi(dashboardToken);
      if (response.status === true) {
        setAverageDetails(response.data ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getCounts = async () => {
    try {
      const response = await getCount(dashboardToken);
      if (response.status === true) {
        setIsGateDetials(response.count ?? {});
        setOrgCreateDate(response.count.from_date ?? "");
        setvisitorDetails(response.count.visitors ?? {});
        setvehicleDetails(response.count.vehicles ?? {});
        setcourierDetails(response.count.couriers ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getpurposes = async () => {
    try {
      const response = await getPurposeApi(dashboardToken);
      if (response.status === true) {
        setpurposesTotal(response.total ?? 0);
        setpurposeslist(response.data ?? []);

        settotalpercentPurpose(response.percent ?? 0);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getEntries = async () => {
    try {
      const response = await getEntryBasedApi(dashboardToken);
      if (response.status === true) {
        setEntryCounts(response.count ?? []);

        setqrPerct(response.count.qr_percent ?? 0);
        setmanualPerct(response.count.manual_percent ?? 0);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getOverStayCount = async () => {
    try {
      const response = await getOverstayCountApi(dashboardToken);
      if (response.status === true) {
        setOverCount(response.count ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getCourierCounts = async () => {
    try {
      const response = await getCourierCountApi(dashboardToken);
      if (response.status === true) {
        setcourierCount(response.count ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getregisCounts = async () => {
    try {
      const response = await getRegisterCountApi(dashboardToken);
      if (response.status === true) {
        setregistCount(response.count ?? {});
        const directPercentage = parseFloat(
          ((response.count.direct / response.count.total) * 100).toFixed(2)
        );
        const schedulePercentage = parseFloat(
          ((response.count.schedule / response.count.total) * 100).toFixed(2)
        );

        setDirectRegisterWidth(directPercentage);
        setPreRegisterWidth(schedulePercentage);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getmonthlycounts = async (type) => {
    try {
      const response = await getMonthlyCountApi(dashboardToken);
      if (response.status === true) {
        setMonthlyList(response.MonthlyAttandence ?? {});
        if (type === "visitor") {
          setmonthlyDiff(response.MonthlyAttandence.visitor.diff ?? 0);
          setmonthlyPercent(response.MonthlyAttandence.visitor.percent ?? 0);
          setmonthlyIsLow(response.MonthlyAttandence.visitor.is_low ?? false);
        } else if (type === "vehicle") {
          setmonthlyDiff(response.MonthlyAttandence.vehicle.diff ?? 0);
          setmonthlyPercent(response.MonthlyAttandence.vehicle.percent ?? 0);
          setmonthlyIsLow(response.MonthlyAttandence.vehicle.is_low ?? false);
        } else if (type === "courier") {
          setmonthlyDiff(response.MonthlyAttandence.courier.diff ?? 0);
          setmonthlyPercent(response.MonthlyAttandence.courier.percent ?? 0);
          setmonthlyIsLow(response.MonthlyAttandence.courier.is_low ?? false);
        }
        setvisitorMonthlyList(response.MonthlyAttandence.visitor.count ?? []);
        setvehicleMonthlyList(response.MonthlyAttandence.vehicle.count ?? []);
        setvcourierMonthlyList(response.MonthlyAttandence.courier.count ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const gettodayCounts = async () => {
    try {
      const response = await getTodayCountApi(dashboardToken);
      if (response.status === true) {
        settodayAttCount(response.TodayAttandence ?? {});
        settodayAttVistCount(response.TodayAttandence.visitors ?? 0);
        settodayAttVehCount(response.TodayAttandence.vehicle ?? 0);
        settodayAttCourCount(response.TodayAttandence.courier ?? 0);
        const Totalvisitor = response.TodayAttandence.visitors.Totalvisitor;
        const Totalvehicle = response.TodayAttandence.vehicle.Totalvehicle;
        const Totalcourier = response.TodayAttandence.courier.Totalcourier;

        // Calculate total count
        const totalCount = Totalvisitor + Totalvehicle + Totalcourier;

        // Calculate percentages
        const vehiclePercentage =
          totalCount > 0 ? ((Totalvehicle / totalCount) * 100).toFixed(2) : 0;
        const courierPercentage =
          totalCount > 0 ? ((Totalcourier / totalCount) * 100).toFixed(2) : 0;
        const visitotPercentage =
          totalCount > 0 ? ((Totalcourier / totalCount) * 100).toFixed(2) : 0;
        settodayAttvalueCount(totalCount);
        settoAttVisitPercent(visitotPercentage);
        settoAttVehPercent(vehiclePercentage);
        settoAttCourPercent(courierPercentage);
        console.log("Vehicle Percentage:", vehiclePercentage + "%");
        console.log("Courier Percentage:", courierPercentage + "%");
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const fontResize = (baseFont, percentage) => {
    const fontSize = baseFont * (1 + percentage / 100);
    return fontSize;
  };
  const countWidget = (fontPercentage) => {
    //`${fontResize(14, fontPercentage)}px`
    return (
      <Col sm={12} md={6} lg={8} xs={8}>
        {/* Visitors Card */}
        <Row>
          <Col sm={12} md={4} className="mt-3">
            <div className="content1">
              <div className="content1-head">
                <img src={user_logo} alt="Visitors" />
                <div className="text-container">
                  <span
                    className="number"
                    style={{ fontSize: `${fontResize(20, fontPercentage)}px` }}
                  >
                    {visitorDetails.total ?? 0}
                  </span>
                  <span
                    className="visitors"
                    style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
                  >
                    Visitors
                  </span>
                </div>
              </div>
              <div className="calculation-container">
                <div
                  className="calculation-row"
                  style={{ fontSize: `${fontResize(12, fontPercentage)}px` }}
                >
                  <span>From last month</span>
                  <span>Average Duration</span>
                </div>
                <div
                  className="calculation-values"
                  style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
                >
                  <div className="calculation-left">
                    <span
                      className={
                        visitorDetails.differenceValue === "lesser"
                          ? "negative"
                          : "positive"
                      }
                    >
                      + {visitorDetails.Percentage} %
                    </span>
                    <span className="highlight-box">
                      <img
                        src={
                          visitorDetails.differenceValue === "lesser"
                            ? down_arrow_red
                            : up_arrow
                        }
                        alt="Increase1"
                        className="icon1"
                      />{" "}
                      {visitorDetails.Difference}
                    </span>
                  </div>
                  <div className="calculation-right">
                    <span>{visitorDetails.InTimeaverage} hrs</span>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          {/* Vehicles Card */}
          <Col sm={12} md={4} className="mt-3">
            <div className="content1">
              <div className="content1-head">
                <img src={van_logo} alt="Vehicles" />
                <div className="text-container">
                  <span
                    className="number"
                    style={{ fontSize: `${fontResize(20, fontPercentage)}px` }}
                  >
                    {vehicleDetails.total ?? 0}
                  </span>
                  <span
                    className="visitors"
                    style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
                  >
                    Vehicles
                  </span>
                </div>
              </div>
              <div className="calculation-container">
                <div
                  className="calculation-row"
                  style={{ fontSize: `${fontResize(12, fontPercentage)}px` }}
                >
                  <span>From last month</span>
                  <span>Average Duration</span>
                </div>
                <div
                  className="calculation-values"
                  style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
                >
                  <div className="calculation-left">
                    <span
                      className={
                        vehicleDetails.differenceValue === "lesser"
                          ? "negative"
                          : "positive"
                      }
                    >
                      + {vehicleDetails.Percentage} %
                    </span>
                    <span className="highlight-box">
                      <img
                        src={
                          vehicleDetails.differenceValue === "lesser"
                            ? down_arrow_red
                            : up_arrow
                        }
                        alt="Increase1"
                        className="icon1"
                      />{" "}
                      {vehicleDetails.Difference}
                    </span>
                  </div>
                  <div className="calculation-right">
                    <span>{vehicleDetails.InTimeaverage} hrs</span>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          {/* Couriers Card */}
          <Col sm={12} md={4} className="mt-3">
            <div className="content1">
              <div className="content1-head">
                <img src={couriers_logo} alt="Couriers" />
                <div className="text-container">
                  <span
                    className="number"
                    style={{ fontSize: `${fontResize(20, fontPercentage)}px` }}
                  >
                    {courierDetails.total ?? 0}
                  </span>
                  <span
                    className="visitors"
                    style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
                  >
                    Couriers
                  </span>
                </div>
              </div>
              <div className="calculation-container">
                <div
                  className="calculation-row"
                  style={{ fontSize: `${fontResize(12, fontPercentage)}px` }}
                >
                  <span>From last month</span>
                  <span>Average Duration</span>
                </div>
                <div
                  className="calculation-values"
                  style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
                >
                  <div className="calculation-left">
                    <span
                      className={
                        courierDetails.differenceValue === "lesser"
                          ? "negative"
                          : "positive"
                      }
                    >
                      + {courierDetails.Percentage} %
                    </span>
                    <span className="highlight-box">
                      <img
                        src={
                          courierDetails.differenceValue === "lesser"
                            ? down_arrow_red
                            : up_arrow
                        }
                        alt="Increase1"
                        className="icon1"
                      />{" "}
                      {courierDetails.Difference}
                    </span>
                  </div>
                  <div className="calculation-right">
                    <span>{courierDetails.InTimeaverage} hrs</span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    );
  };

  const averageGateInWidget = (fontPercentage) => {
    return (
      <Col className="mt-3" sm={12} md={6} lg={4} xs={4}>
        <div className="gate-activities">
          <div className="gate-content1">
            <h3 style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}>
              Average Gate in Activities
            </h3>
            <div className="gate-table">
              <div className="gate-row">
                <span
                  className="gate-cell"
                  style={{ fontSize: `${fontResize(28, fontPercentage)}px` }}
                >
                  {averageDetails.visitors ?? 0}
                </span>
                <span
                  className="gate-cell"
                  style={{ fontSize: `${fontResize(28, fontPercentage)}px` }}
                >
                  {averageDetails.vehicle ?? 0}
                </span>
                <span
                  className="gate-cell"
                  style={{ fontSize: `${fontResize(28, fontPercentage)}px` }}
                >
                  {averageDetails.courier ?? 0}
                </span>
              </div>
              <div className="gate-row">
                <span
                  className="gate-text"
                  style={{ fontSize: `${fontResize(12.5, fontPercentage)}px` }}
                >
                  Visitor entries
                </span>
                <span
                  className="gate-text"
                  style={{ fontSize: `${fontResize(12.5, fontPercentage)}px` }}
                >
                  Vehicles entries
                </span>
                <span
                  className="gate-text"
                  style={{ fontSize: `${fontResize(12.5, fontPercentage)}px` }}
                >
                  Courier entries
                </span>
              </div>
            </div>
            <p
              className="gate-records pb-0 mb-0"
              style={{ fontSize: `${fontResize(11, fontPercentage)}px` }}
            >
              <img src={average_gate} alt="" />
              From <span className="highlighted">{orgCreateDate}</span> to
              present records
            </p>
          </div>
        </div>
      </Col>
    );
  };

  const purposeVisitorWidget = (fontPercentage) => {
    return (
      <Col sm={12} md={3} lg={4} className="mt-3">
        <div className="purpose-based-container">
          <h3 style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}>
            Purpose based visitor
          </h3>
          <div className="purpose-based">
            <div className="purpose-header">
              <span
                className="number"
                style={{ fontSize: `${fontResize(20, fontPercentage)}px` }}
              >
                {totalpercentPurpose}
                <span className="percentage"> %</span>
              </span>
              <div
                className="text"
                style={{
                  fontSize: `${fontResize(16, fontPercentage)}px`,
                  width: "100%",
                }}
              >
                <span>Coverage of these top 5 purposes: %</span>
              </div>
            </div>

            <div className="purpose-content" style={{ width: "100%" }}>
              {purposeslist.map((purpose, index) => (
                <div key={index}>
                  <div
                    className="purpose-name"
                    style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
                  >
                    {purpose.name}{" "}
                  </div>
                  <div className="purpose-item">
                    {/* <img src={purpose.icon} alt={purpose.name} /> */}

                    <progress
                      className="custom-progress"
                      value={purpose.count}
                      max={purposesTotal}
                    />
                    {/* <div className="progress-bar">
                            <div className="progress" style={{ width: `${purpose.percentage}%` }}></div>
                        </div>  */}
                    <span
                      className="count"
                      style={{
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                      }}
                    >
                      {purpose.count}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Col>
    );
  };

  const entryWidget = (fontPercentage) => {
    return (
      <Col sm={12} md={5} lg={4} className="mt-3">
        <div>
          <div className="entry-container">
            <div className="entry-box">
              <h3 style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}>
                QR Entry
              </h3>
              <p
                className="mb-0"
                style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
              >
                Ensures secured gate-in process
              </p>
              <div className="qr-entry-bar">
                <div className="circle-progress-bar">
                  <div className="circle-container">
                    <CircularProgressbar
                      value={entryCounts.qr_code}
                      maxValue={entryCounts.total}
                      strokeWidth={5}
                      circleRatio={0.8}
                      styles={buildStyles({
                        pathColor: "#5DCB8C",
                        trailColor: "#e0e0e0",
                        textSize: "16px",
                        rotation: "0.600",
                      })}
                    />
                    <div
                      className="progress-text"
                      style={{
                        fontSize: `${fontResize(14, fontPercentage)}px`,
                      }}
                    >
                      <p>Total</p>
                      <span>{entryCounts.qr_code} </span>
                    </div>
                  </div>
                </div>
              </div>
              <span
                className="entries"
                style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
              >
                <img src={qr_icon} alt="QR Icon" />
                QR entry accounts for {qrPerct} % of the total entries
              </span>
            </div>

            <div className="manual-box">
              <h3 style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}>
                Manual Entry
              </h3>
              <p
                className="mb-0"
                style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
              >
                Ensures secured gate-in process
              </p>
              <div className="manual-bar">
                <div className="circle-progress-bar">
                  <div className="circle-container">
                    <CircularProgressbar
                      value={entryCounts.manual}
                      maxValue={entryCounts.total}
                      strokeWidth={5}
                      circleRatio={0.8}
                      styles={buildStyles({
                        pathColor: "#5DCB8C",
                        trailColor: "#e0e0e0",
                        textSize: "16px",
                        rotation: "0.600",
                      })}
                    />
                    <div
                      className="progress-text"
                      style={{
                        fontSize: `${fontResize(14, fontPercentage)}px`,
                      }}
                    >
                      <p>Total</p>
                      <span>{entryCounts.manual} </span>
                    </div>
                  </div>
                </div>
              </div>
              <span
                className="entries"
                style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
              >
                <img src={manual_entr_ic} alt="QR Icon" />
                Manual entry accounts for {manualPerct} % of the total entries
              </span>
            </div>
          </div>
        </div>
      </Col>
    );
  };

  const upcomingVisitorWidget = (fontPercentage) => {
    return (
      <Col sm={12} md={4} lg={4} className="mt-3">
        <div className="gate-content2">
          <div className="gate-cards" style={{ flex: 3 }}>
            <div className="gate-card" style={{ flex: 1 }}>
              <img className="gate-img" src={scheduled_icon} alt="" />
              <span
                className="gate-text2"
                style={{ fontSize: `${fontResize(12, fontPercentage)}px` }}
              >
                Upcoming <br /> Scheduled Visits
              </span>
              <span
                className="gate-number"
                style={{ fontSize: `${fontResize(20, fontPercentage)}px` }}
              >
                {overCount.schedule_count}
              </span>
            </div>

            <div className="gate-card" style={{ flex: 1 }}>
              <img className="gate-img" src={overstayed_icon} alt="" />
              <span
                className="gate-text2"
                style={{ fontSize: `${fontResize(12, fontPercentage)}px` }}
              >
                Overstayed <br /> Visitors
              </span>
              <span
                className="gate-number"
                style={{ fontSize: `${fontResize(20, fontPercentage)}px` }}
              >
                {overCount.visitor_count}
              </span>
            </div>

            <div className="gate-card" style={{ flex: 1 }}>
              <img className="gate-img" src={vehicles_icon} alt="" />
              <span
                className="gate-text2"
                style={{ fontSize: `${fontResize(12, fontPercentage)}px` }}
              >
                Overstayed <br /> Vehicles
              </span>
              <span
                className="gate-number"
                style={{ fontSize: `${fontResize(20, fontPercentage)}px` }}
              >
                {overCount.vehicle_count}
              </span>
            </div>
          </div>
        </div>
        <div
          className="gate-content3 mt-3"
          style={{
            alignItems: "center",
            padding: "12px",
            /*  width: "105%", */
          }}
        >
          <h5 style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}>
            Courier Status
          </h5>
          <div
            className="courier-table"
            style={{
              maxWidth: "445px",
            }}
          >
            <div className="courier-row">
              {/* Background union shape */}
              <img
                src={union_icon}
                alt=""
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "cover",
                  /* maxWidth: "473px", */
                }}
                className="union-image"
              />

              {/* Circles above the image */}
              <div className="courier-status">
                <div className="courier-cell">
                  <span
                    className="courier-label"
                    style={{ fontSize: `${fontResize(12, fontPercentage)}px` }}
                  >
                    Received
                  </span>
                  <span
                    className="courier-text"
                    style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
                  >
                    {courierCount.received ?? 0}
                  </span>
                </div>
                <div className="courier-cell">
                  <span
                    className="courier-label"
                    style={{ fontSize: `${fontResize(12, fontPercentage)}px` }}
                  >
                    Total
                  </span>
                  <span
                    className="courier-text"
                    style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
                  >
                    {courierCount.total ?? 0}
                  </span>
                </div>
                <div className="courier-cell">
                  <span
                    className="courier-label"
                    style={{ fontSize: `${fontResize(12, fontPercentage)}px` }}
                  >
                    Unreceived
                  </span>
                  <span
                    className="courier-text"
                    style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
                  >
                    {courierCount.not_received ?? 0}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Col>
    );
  };

  const courierStatusWidget = () => {};

  const totalRegistraionWidget = (fontPercentage) => {
    return (
      <Col sm={12} md={3} lg={4} className="mt-3">
        <div className="all-booking hide-scroll">
          <div className="registerations">
            <div className="registerations-count">
              <p style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}>
                Total registrations count
              </p>
              <div className="right-content">
                <span
                  className="number"
                  style={{ fontSize: `${fontResize(20, fontPercentage)}px` }}
                >
                  {registCount.total ?? 0}
                </span>
                <span
                  className="text"
                  style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
                >
                  From {orgCreateDate}
                </span>
              </div>
            </div>
            <div className="register">
              <div className="pre-register">
                <div className="pre-register-content">
                  {/* <span className="reg-head">Pre - Register</span> */}
                  {/* <span className="number">{registCount.schedule ?? 0}</span> */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span
                      className="reg-head"
                      style={{
                        fontSize: `${fontResize(16, fontPercentage)}px`,
                      }}
                    >
                      Pre - Register
                    </span>
                    <span
                      className="number"
                      style={{
                        fontSize: `${fontResize(20, fontPercentage)}px`,
                      }}
                    >
                      {registCount.schedule ?? 0}
                    </span>
                  </div>

                  <div className="pre-register-bar">
                    <span
                      className="text"
                      style={{
                        fontSize: `${fontResize(12, fontPercentage)}px`,
                      }}
                    >
                      Count of this entries
                    </span>
                    {/* Progress Bar */}
                    <div
                      className="preregister-bar-container"
                      onMouseEnter={() => setHoveredBar("preRegister")}
                      onMouseLeave={() => setHoveredBar(null)}
                    >
                      <div
                        className="register-bar"
                        style={{ width: `${preRegisterWidth}%` }}
                      ></div>

                      {/* Show percentage only when hovering */}
                      {hoveredBar === "preRegister" && (
                        <div
                          className="hover-number"
                          style={{
                            fontSize: `${fontResize(12, fontPercentage)}px`,
                            left: `${Math.min(preRegisterWidth, 100)}%`,
                            transform:
                              preRegisterWidth > 100
                                ? "translateX(-100%)"
                                : "translateX(0)",
                          }}
                        >
                          {preRegisterWidth}%
                        </div>
                      )}
                    </div>

                    <div
                      className="progress-labels"
                      style={{
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                      }}
                    >
                      <span>0%</span>
                      <span>100%</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="direct-register">
                <div className="direct-register-content">
                  {/* <span className="reg-head">Direct Registration</span>
                   */}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span
                      className="reg-head"
                      style={{
                        fontSize: `${fontResize(16, fontPercentage)}px`,
                      }}
                    >
                      Direct Registration
                    </span>
                    <span
                      className="number"
                      style={{
                        fontSize: `${fontResize(20, fontPercentage)}px`,
                      }}
                    >
                      {registCount.direct ?? 0}
                    </span>
                  </div>
                  <div className="direct-register-bar">
                    {/* <span className="number">{registCount.direct ?? 0}</span> */}
                    <span
                      className="text"
                      style={{
                        fontSize: `${fontResize(12, fontPercentage)}px`,
                      }}
                    >
                      Count of this entries
                    </span>

                    {/* Progress Bar */}
                    <div
                      className="preregister-bar-container"
                      onMouseEnter={() => setHoveredBar("directRegister")}
                      onMouseLeave={() => setHoveredBar(null)}
                    >
                      <div
                        className="register-bar"
                        style={{ width: `${directRegisterWidth}%` }}
                      ></div>

                      {/* Show percentage only when hovering */}
                      {hoveredBar === "directRegister" && (
                        <div
                          className="hover-number"
                          style={{
                            fontSize: `${fontResize(12, fontPercentage)}px`,
                            left: `${Math.min(directRegisterWidth, 100)}%`,
                            transform:
                              directRegisterWidth > 100
                                ? "translateX(-100%)"
                                : "translateX(0)",
                          }}
                        >
                          {directRegisterWidth}%
                        </div>
                      )}
                    </div>

                    <div
                      className="progress-labels"
                      style={{
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                      }}
                    >
                      <span>0%</span>
                      <span>100%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Col>
    );
  };

  const monthlyBookingWidget = (fontPercentage) => {
    return (
      <Col sm={12} md={5} lg={4} className="mt-3">
        <div className="booking">
          <div className="booking-head">
            <span
              className="booking-head1"
              style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}
            >
              Monthly Bookings
            </span>
            {/* <span className="booking-head2" onClick={() => setIsOpen(!isOpen)}>
                {selectedMonth}, {selectedYear} <img src={booking_vector} alt="" />
              </span> */}

            {isOpen && (
              <div
                className="downarrow"
                style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}
              >
                <div className="month-list">
                  {months.map((month) => (
                    <div
                      key={month}
                      className={`month-item ${
                        month === selectedMonth ? "active" : ""
                      }`}
                      onClick={() => handleSelect(month, selectedYear)}
                    >
                      {month}
                    </div>
                  ))}
                </div>
                <div className="year-list">
                  {years.map((year) => (
                    <div
                      key={year}
                      className={`year-item ${
                        year === selectedYear ? "active" : ""
                      }`}
                      onClick={() => handleSelect(selectedMonth, year)}
                    >
                      {year}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div
            className="tri-services"
            style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
          >
            <span
              className={`service-item ${
                activeService === "visitor" ? "active" : ""
              }`}
              onClick={() => {
                setActiveService("visitor");
                getmonthlycounts("visitor");
              }}
            >
              Visitor
            </span>
            <span
              className={`service-item ${
                activeService === "vehicle" ? "active" : ""
              }`}
              onClick={() => {
                setActiveService("vehicle");
                getmonthlycounts("vehicle");
              }}
            >
              Vehicle
            </span>
            <span
              className={`service-item ${
                activeService === "courier" ? "active" : ""
              }`}
              onClick={() => {
                setActiveService("courier");
                getmonthlycounts("courier");
              }}
            >
              Courier
            </span>
          </div>
          <div className="book-graph">
            <div className="book-graph-content1">
              <h3 style={{ fontSize: `${fontResize(32, fontPercentage)}px` }}>
                {monthlyPercent} %
              </h3>
              <p
                className="book-graph-content2"
                style={{ fontSize: `${fontResize(12, fontPercentage)}px` }}
              >
                Increased from last month
              </p>
              <div className="book-graph-content3 px-2 py-1">
                <p
                  className="increased_count my-0"
                  style={{ fontSize: `${fontResize(12, fontPercentage)}px` }}
                >
                  <img src={line_border} alt="increase icon" />
                  {monthlyIsLow === true ? "Decreased" : "Increased"} count
                  <span
                    className="book-border"
                    style={{ fontSize: `${fontResize(13, fontPercentage)}px` }}
                  >
                    <img
                      src={monthlyIsLow === true ? down_arrow_red : up_arrow}
                      alt="increase icon"
                    />
                    {monthlyDiff}
                  </span>
                </p>
              </div>
              <BarChart
                dataList={
                  activeService === "visitor"
                    ? visitormonthlyList
                    : activeService === "vehicle"
                    ? vehiclemonthlyList
                    : couriermonthlyList
                }
              />
            </div>
          </div>
        </div>
      </Col>
    );
  };

  const totdayAttendanceWidget = (fontPercentage) => {
    return (
      <Col sm={12} md={4} lg={4} className="mt-3">
        <div className="total-attendance">
          <div className="total-attendance-head">
            <span
              className="total-attendance-head1"
              style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}
            >
              {" "}
              Today Attendance
            </span>
            {/* <span className="booking-head2" onClick={() => setIsOpen(!isOpen)}>
                        {selectedMonth}, {selectedYear} <img src={booking_vector} alt="" />
                      </span> */}
            {/* <div >
                        <DatePicker
                          selected={selectedDate}
                          onChange={(date) => setSelectedDate(date)} 
                          // popperPlacement="top-start" // or "top-end", "auto", etc.
                          // popperModifiers={[
                          //   {
                          //     name: 'preventOverflow',
                          //     options: {
                          //       boundary: 'viewport',
                          //     },
                          //   },
                          // ]}
                          customInput={
                            <div
                              className="booking-head2"
                            >
                              {selectedDate.toDateString()}<img style={{ paddingBottom: '6px' }} src={booking_vector} alt="" />
                            </div>
                          }
                        />
                      </div> */}
            {isAttendanceOpen && (
              <div className="droparrow">
                <div className="day-list">
                  {days.map((day) => (
                    <div
                      key={day}
                      className={`day-item ${
                        day === selectedDay ? "active" : ""
                      }`}
                      onClick={() =>
                        handleAttendanceSelect(
                          day,
                          selectedAttendanceMonth,
                          selectedAttendanceYear
                        )
                      }
                    >
                      {day}
                    </div>
                  ))}
                </div>
                <div className="month-list">
                  {months.map((month) => (
                    <div
                      key={month}
                      className={`month-item ${
                        month === selectedAttendanceMonth ? "active" : ""
                      }`}
                      onClick={() =>
                        handleAttendanceSelect(
                          selectedDay,
                          month,
                          selectedAttendanceYear
                        )
                      }
                    >
                      {month}
                    </div>
                  ))}
                </div>
                <div className="year-list">
                  {years.map((year) => (
                    <div
                      key={year}
                      className={`year-item ${
                        year === selectedAttendanceYear ? "active" : ""
                      }`}
                      onClick={() =>
                        handleAttendanceSelect(
                          selectedDay,
                          selectedAttendanceMonth,
                          year
                        )
                      }
                    >
                      {year}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="total-attendance-content1">
            <h3 style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}>
              {" "}
              {todayAttvalueCount}
            </h3>
            <p
              className="total-attendance-content2"
              style={{ fontSize: `${fontResize(12, fontPercentage)}px` }}
            >
              Overall today entries of your orgnization
            </p>
            <div className="total-attendance-content3">
              <p
                className="increased_count my-0"
                style={{ fontSize: `${fontResize(12, fontPercentage)}px` }}
              >
                <span
                  className="total-attendance-highlighted"
                  style={{
                    fontSize: `${fontResize(12, fontPercentage)}px`,
                    color:
                      todayAttCount.is_low === true ? "#FF4444" : "#2C8C53",
                  }}
                >
                  {todayAttCount.is_low === true ? "-" : "+"}
                  {todayAttCount.percent}%{" "}
                </span>
                <span> From yesterday </span>
                <span
                  className="book-border"
                  style={{ fontSize: `${fontResize(13, fontPercentage)}px` }}
                >
                  <img
                    src={
                      todayAttCount.is_low === true ? down_arrow_red : up_arrow
                    }
                    alt="increase icon"
                  />
                  {todayAttCount.diff}
                </span>
              </p>
            </div>
          </div>
          <div className="total-attendance-bar">
            <div className="attendance-bar-container">
              <div
                className="attendance-bar-visitors"
                style={{ width: `${toAttVisitPercent}%` }}
              ></div>
              <div
                className="attendance-bar-vehicles"
                style={{ width: `${toAttVehPercent}%` }}
              ></div>

              <div
                className="attendance-bar-couriers"
                style={{ width: `${toAttCourPercent}%` }}
              ></div>
            </div>
          </div>
          <div className="three-content">
            <div className="total-attendance-cards">
              <div className="total-attendance-card">
                <img
                  className="total-attendance-img"
                  src={total_attendance_user}
                  alt=""
                />
                <span
                  className="total-attendance-text2"
                  style={{ fontSize: `${fontResize(12.5, fontPercentage)}px` }}
                >
                  Visitor
                </span>
                <span
                  className="total-attendance-number"
                  style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}
                >
                  {todayAttVistCount.Totalvisitor}
                </span>
              </div>

              <div className="total-attendance-card">
                <img
                  className="total-attendance-img"
                  src={total_attendance_vehicle}
                  alt=""
                />
                <span
                  className="total-attendance-text2"
                  style={{ fontSize: `${fontResize(12.5, fontPercentage)}px` }}
                >
                  Vehicles
                </span>
                <span
                  className="total-attendance-number"
                  style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}
                >
                  {todayAttVehCount.Totalvehicle ?? 0}
                </span>
              </div>

              <div className="total-attendance-card">
                <img
                  className="total-attendance-img"
                  src={total_attendance_courier}
                  alt=""
                />
                <span
                  className="total-attendance-text2"
                  style={{ fontSize: `${fontResize(12.5, fontPercentage)}px` }}
                >
                  Couriers
                </span>
                <span
                  className="total-attendance-number"
                  style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}
                >
                  {todayAttCourCount.Totalcourier ?? 0}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Col>
    );
  };

  return (
    <Container
      fluid
      className="main-container"
      style={{
        fontFamily: "Epilogue",
        width: "100vw",
        display: "flex",
        paddingLeft: "0px",
        paddingRight: "0px",
      }}
    >
      <div style={{ width: "100vw" }}>
        <div
          className="mx-1"
          style={{ width: "100vw", display: "flex", flexDirection: "column" }}
        >
          <div style={{ width: "100vw", padding: "16px" }}>
            <div className="dashboard">
              <div className="dashboard-head">
                Dashboard
                <div className="dashboard-content">
                  From the date of{" "}
                  <span>
                    {orgCreateDate} to{" "}
                    {new Date().toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </span>
                </div>
              </div>
            </div>

            <Row className="section-part" style={{ width: "100vw" }}>
              {sortedWidgetList?.map((widget, i) => {
                if (widget.name === "Count details" && widget.status === true) {
                  var fontPercentage = 0;
                  if (widget.width === "custom") {
                    fontPercentage = widget.width_size ?? 0;
                  } else if (widget.width === "large") {
                    fontPercentage = 30;
                  } else if (widget.width === "medium") {
                    fontPercentage = 0;
                  } else if (widget.width === "small") {
                    fontPercentage = -20;
                  }
                  return countWidget(fontPercentage);
                }
                if (
                  widget.name === "Average Gate in Activities" &&
                  widget.status === true
                ) {
                  var fontPercentage = 0;
                  if (widget.width === "custom") {
                    fontPercentage = widget.width_size ?? 0;
                  } else if (widget.width === "large") {
                    fontPercentage = 30;
                  } else if (widget.width === "medium") {
                    fontPercentage = 0;
                  } else if (widget.width === "small") {
                    fontPercentage = -20;
                  }
                  return averageGateInWidget(fontPercentage);
                }
                if (
                  widget.name === "Purpose based visitor" &&
                  widget.status === true
                ) {
                  var fontPercentage = 0;
                  if (widget.width === "custom") {
                    fontPercentage = widget.width_size ?? 0;
                  } else if (widget.width === "large") {
                    fontPercentage = 30;
                  } else if (widget.width === "medium") {
                    fontPercentage = 0;
                  } else if (widget.width === "small") {
                    fontPercentage = -20;
                  }
                  return purposeVisitorWidget(fontPercentage);
                }
                if (widget.name === "Entry based" && widget.status === true) {
                  var fontPercentage = 0;
                  if (widget.width === "custom") {
                    fontPercentage = widget.width_size ?? 0;
                  } else if (widget.width === "large") {
                    fontPercentage = 30;
                  } else if (widget.width === "medium") {
                    fontPercentage = 0;
                  } else if (widget.width === "small") {
                    fontPercentage = -20;
                  }
                  return entryWidget(fontPercentage);
                }
                if (
                  widget.name === "Upcoming and Overstayed visitors" &&
                  widget.status === true
                ) {
                  var fontPercentage = 0;
                  if (widget.width === "custom") {
                    fontPercentage = widget.width_size ?? 0;
                  } else if (widget.width === "large") {
                    fontPercentage = 30;
                  } else if (widget.width === "medium") {
                    fontPercentage = 0;
                  } else if (widget.width === "small") {
                    fontPercentage = -20;
                  }
                  return upcomingVisitorWidget(fontPercentage);
                }
                if (
                  widget.name === "Total registrations" &&
                  widget.status === true
                ) {
                  var fontPercentage = 0;
                  if (widget.width === "custom") {
                    fontPercentage = widget.width_size ?? 0;
                  } else if (widget.width === "large") {
                    fontPercentage = 30;
                  } else if (widget.width === "medium") {
                    fontPercentage = 0;
                  } else if (widget.width === "small") {
                    fontPercentage = -20;
                  }
                  return totalRegistraionWidget(fontPercentage);
                }
                if (
                  widget.name === "Monthly bookings" &&
                  widget.status === true
                ) {
                  var fontPercentage = 0;
                  if (widget.width === "custom") {
                    fontPercentage = widget.width_size ?? 0;
                  } else if (widget.width === "large") {
                    fontPercentage = 30;
                  } else if (widget.width === "medium") {
                    fontPercentage = 0;
                  } else if (widget.width === "small") {
                    fontPercentage = -20;
                  }
                  return monthlyBookingWidget(fontPercentage);
                }
                if (
                  widget.name === "Today attendance" &&
                  widget.status === true
                ) {
                  var fontPercentage = 0;
                  if (widget.width === "custom") {
                    fontPercentage = widget.width_size ?? 0;
                  } else if (widget.width === "large") {
                    fontPercentage = 30;
                  } else if (widget.width === "medium") {
                    fontPercentage = 0;
                  } else if (widget.width === "small") {
                    fontPercentage = -20;
                  }
                  return totdayAttendanceWidget(fontPercentage);
                }
              })}
            </Row>
            <Row>
              {/* <Col sm={12} md={9} >
                <Row>
                  
                </Row>
              </Col> */}
            </Row>
            <Row></Row>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default GateNewDashboard;
